import * as actionTypes from '../action-types'

const initialState = {
    labList:[],
    treeList:[],
    token:'',
    nickName:'',
    userObj:{},
}

export default function user (state = initialState, action={}) {
    switch (action.type) {
        case actionTypes.LOGIN_IN:
            return Object.assign({},state,action.user);
        case actionTypes.LOGIN_OUT:
            return initialState;
        case actionTypes.USERINFO_UPDATE:
            return Object.assign({},state,action.user);
        case "IS_SHOW_LOADING":
            return {
                ...state,
                isFetchUserSuccess: !action.bool
            }
        default:
            return state
    }
}